import styled from "styled-components";
import { FancyTitle } from "./components/fancyTitle";
import { VerticalLine } from "./components/lines";
import { FancyButton } from "./components/button";
import { useNuovoRistoranteQuery } from "../../generated/graphql";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 400px) minmax(400px, 1fr) minmax(0, 400px);
  width: 100%;

  z-index: 1;
  p {
    max-width: 400px;
    text-align: center;
    padding: 0 0;
    margin: 0;
  }
  @media screen and (max-width: 900px) {
    grid-template-columns: minmax(0, 200px) minmax(200px, 1fr) minmax(0, 200px);
    ${VerticalLine} {
      height: 30px;
    }
  }
`;
const ImgSmall = styled.img`
  width: 60%;

  object-fit: contain;
  @media screen and (max-width: 900px) {
    width: 80%;
  }
`;
const ImgBig = styled.img`
  width: 100%;

  object-fit: contain;
  max-height: 400px;
`;

const SideColumns = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 40px;

  min-width: 0;
  justify-content: space-between;
`;
const DivImgBig = styled.div``;
const LeftColumn = styled(SideColumns)`
  grid-column: 1/2;
  ${DivImgBig} {
    align-self: start;
  }
`;
const RightColumn = styled(SideColumns)`
  grid-column: 3/4;
  align-items: start;
  padding-top: 90px;
  ${DivImgBig} {
    align-self: end;
  }
`;

const MiddleColumn = styled.div`
  margin-top: 50px;
  grid-column: 2/3;
  justify-content: space-between;
  display: flex;
  flex-direction: column;

  align-items: center;
  @media screen and (max-width: 900px) {
    padding: 20px;
    margin-top: 0px;
  }
`;
export function ImgScroll() {
  const { data } = useNuovoRistoranteQuery();

  return (
    <GridContainer>
      <LeftColumn>
        <DivImgBig>
          <ImgBig src="kum/imgleft/0.webp" />
        </DivImgBig>
        <ImgSmall src="kum/imgleft/1.webp" />
        <DivImgBig>
          <ImgBig src="kum/imgleft/2.webp" />
        </DivImgBig>
        <ImgSmall src="kum/imgleft/3.webp" />
      </LeftColumn>

      <MiddleColumn>
        <FancyTitle
          text={data?.nuovoRistorante?.cucinaTitolo || ""}
          double
        ></FancyTitle>
        {data?.nuovoRistorante?.testiCucina?.map((val) => (
          <>
            <p key={val}>{val}</p> <VerticalLine height="150px" />
          </>
        ))}
      
      </MiddleColumn>
      <RightColumn>
        <DivImgBig>
          <ImgBig src="kum/imgright/0.webp" />
        </DivImgBig>
        <ImgSmall src="kum/imgright/1.webp" />
        <DivImgBig>
          <ImgBig src="kum/imgright/2.webp" />
        </DivImgBig>
        <DivImgBig>
          <ImgBig src="kum/imgright/3.webp" />
        </DivImgBig>
      </RightColumn>
    </GridContainer>
  );
}
